import React from 'react';
import { Table, Button, ButtonToolbar } from 'react-bootstrap';
import {
    DATE_TIME_FORMAT, DATE_FORMAT, TIME_FORMAT, STARTDATE_TEMPLATE, ENDDATE_TEMPLATE, POLLSTARTDATE_TEMPLATE, POLLENDDATE_TEMPLATE,
    POLL_END_DATE, POLL_START_DATE, POLL_STATUS, NO_OCCUPATION_PROVIDED, EMPTY_STRING, OCCUPATION, NO_COMPANY_CODE, COMPANY_CODE, MEMBER_NAME,
    MEMBER_NO, IS_PRIMARY_NUMBER, MEMBER_PRIMARY, NON_OFFICER, OFFICER, IS_OFFICER, IS_OFFICER_NUMBER, CALENDAR_ISOFFICER, CLOSED, NOT_YET_STARTED, STARTDATETIME_TEMPLATE,
    CALENDAR_STATUS, UNSUBSCRIBED_TEMPLATE, SUBSCRIBED_TEMPLATE, SUBSCRIBED_NUMBER, IS_SUBSCRIBED_TEMPLATE, ENDDATETIME_TEMPLATE, TO_DASH,
    CALENDARTIME_TEMPLATE, TO, CALENDARDATE_TEMPLATE, ONGOING, DONE, CREATED_USERID, POLLTYPE_ID, POLLTYPEID_NUMBER, SURVEY, ELECTION, MESSAGE, PENDING_ADVERTISEMENTS,
    POLL_DESCRIPTION, POLL_TITLE, CALENDAR_TITLE, TITLE, ACTIONS, IS_LIVE, IS_ALL_STAR_GAME, IS_LIVE_NUMBER, IS_ALL_START_GAME_NUMBER, LIVE, REPLAY, YES, NO,
    VIDEO_DATE_TEMPLATE
} from '../../utils/constants';
import moment from 'moment';
import { FormCheck } from 'react-bootstrap'
import parse from 'html-react-parser';
import { isNullOrUndefined } from 'util';
import Truncate from 'react-truncate-html';


var date = new Date();
var timestamp = date.getTime();

let TableTemplate = (props) => {
    //Renders table header
    const TableHeader = props.tableHeader && props.tableHeader.map((header, i) => {
        return <th key={i} className={ACTIONS === header ? "center-header actions-width" : "center-header"}>{header}</th>;
    });

    //Renders table row
    const TableList = props.tableList && 0 < props.tableList.length ? (
        props.tableList.map((row, i) => {
            return (
                <tr key={i} className="center-header">
                    {RenderRow(row, i)}
                    {props.rowButtons ? RenderButtons(row) : null}
                </tr>
            );
        })
    ) : <tr><td className="col-center" colSpan={props.tableHeader.length}>No records found</td></tr>

    //Renders row data
    function RenderRow(data, index) {
        return (
            props.tableColumns.map((column, i) => {
                if ((STARTDATE_TEMPLATE === column || ENDDATE_TEMPLATE === column || POLLSTARTDATE_TEMPLATE === column || POLLENDDATE_TEMPLATE === column) && PENDING_ADVERTISEMENTS !== props.tableName) {
                    return (
                        <td key={i}>{moment(data[column]).format(DATE_TIME_FORMAT)}</td>
                    );
                }
                if ((PENDING_ADVERTISEMENTS === props.tableName) && (STARTDATE_TEMPLATE === column || ENDDATE_TEMPLATE === column)) {
                    return (
                        <td key={i}>{moment(data[column]).format(DATE_FORMAT)}</td>
                    );
                }

                if (CALENDARDATE_TEMPLATE === column) {
                    return (
                        <td key={i}>{moment(data[STARTDATETIME_TEMPLATE]).format(DATE_FORMAT) + TO + moment(data[ENDDATETIME_TEMPLATE]).format(DATE_FORMAT)}</td>
                    );
                }

                if (CALENDARTIME_TEMPLATE === column) {
                    return (
                        <td key={i}>{moment(data[STARTDATETIME_TEMPLATE]).format(TIME_FORMAT) + TO_DASH + moment(data[ENDDATETIME_TEMPLATE]).format(TIME_FORMAT)}</td>
                    );
                }

                if (IS_SUBSCRIBED_TEMPLATE === column) {

                    if (SUBSCRIBED_NUMBER === data[column]) {
                        return (
                            <td key={i} className="td-align">
                                <p>
                                    <span className="dot-green"></span><span className="text-status">{SUBSCRIBED_TEMPLATE}</span>
                                </p>
                            </td>
                        );
                    }
                    else {
                        return (
                            <td key={i} className="td-align">
                                <p>
                                    <span className="dot-red"></span><span className="text-status">{UNSUBSCRIBED_TEMPLATE}</span>
                                </p>
                            </td>
                        );
                    }
                }

                if (CALENDAR_STATUS === column) {

                    if (moment(timestamp).isBetween(moment(data[STARTDATETIME_TEMPLATE]), moment(data[ENDDATETIME_TEMPLATE]))) {
                        return (
                            <td key={i}>{ONGOING}</td>
                        );
                    }
                    else if (moment(timestamp).isBefore(moment(data[STARTDATETIME_TEMPLATE]))) {
                        return (
                            <td key={i}>{NOT_YET_STARTED}</td>
                        );
                    }
                    else {
                        return (
                            <td key={i}>{DONE}</td>
                        );
                    }
                }

                if (CALENDAR_ISOFFICER === column) {

                    if (IS_OFFICER_NUMBER === Number(data[IS_OFFICER])) {
                        return (
                            <td key={i} className="td-align">
                                <p>
                                    <span className="dot-green"></span><span className="text-status">{OFFICER}</span>
                                </p>
                            </td>
                        );
                    }
                    else {
                        return (
                            <td key={i} className="td-align">
                                <p>
                                    <span className="dot-red"></span><span className="text-status">{NON_OFFICER}</span>
                                </p>
                            </td>
                        );
                    }
                }


                if (MEMBER_PRIMARY === column) {
                    return (
                        <td key={i}>
                            <FormCheck onChange={(event) => props.handleCheckboxChanges(event, index)} value={data.isPrimaryUser} name="isPrimaryUser" type="checkbox" checked={IS_PRIMARY_NUMBER === data.isPrimaryUser}></FormCheck>
                        </td>
                    )
                }

                if (MEMBER_NO === column) {
                    return (
                        <td key={i}>{!isNullOrUndefined(props.activePage) && 1 < props.activePage ? ((props.activePage - 1) * 25) + (index + 1) : index + 1}</td>
                    );
                }

                if (MEMBER_NAME === column) {
                    return (
                        <td key={i}>{data.lastName + ", " + data.firstName}</td>
                    )
                }

                if (COMPANY_CODE === column) {
                    if (isNullOrUndefined(data[column])) {
                        return (
                            <td key={i}>
                                <b><i>{NO_COMPANY_CODE}</i></b>
                            </td>
                        )
                    }
                }

                if (OCCUPATION === column) {
                    if (EMPTY_STRING === data[column]) {
                        return (
                            <td key={i}>
                                <b><i>{NO_OCCUPATION_PROVIDED}</i></b>
                            </td>
                        )
                    }
                }




                if (POLL_STATUS === column) {

                    if (moment(timestamp).isBetween(moment(data[POLL_START_DATE]), moment(data[POLL_END_DATE]))) {
                        return (
                            <td key={i}>{ONGOING}</td>
                        );
                    }
                    else if (moment(timestamp).isBefore(moment(data[POLL_START_DATE]))) {
                        return (
                            <td key={i}>{NOT_YET_STARTED}</td>
                        );
                    }
                    else {
                        return (
                            <td key={i}>{CLOSED}</td>
                        );
                    }
                }

                if (CREATED_USERID === column) {
                    return (
                        <td key={i}>{data[column].firstName} {data[column].lastName}</td>
                    );
                }

                if (POLLTYPE_ID === column) {
                    if (POLLTYPEID_NUMBER === data[column]) {
                        return (
                            <td key={i}>{SURVEY}</td>
                        );
                    }
                    return (
                        <td key={i}>{ELECTION}</td>
                    );  
                }

                if (CALENDAR_TITLE === column || TITLE === column) {
                    return (
                        <td key={i} className="message" >{parse(data[column])}</td>
                    );
                }

                if (MESSAGE === column) {
                    return (
                        <td key={i} style={{maxWidth: '400px'}}>
                            <Truncate
                                lines={1}
                                dangerouslySetInnerHTML={{
                                    __html: data[column]
                                }}
                            />
                        </td>
                    );
                }

                if (POLL_TITLE === column || POLL_DESCRIPTION === column) {
                    return (
                        <td key={i} className="message-poll" >{parse(data[column])}</td>
                    );
                }

                if (IS_LIVE === column) {
                    if (IS_LIVE_NUMBER === data[column]) {
                        return (
                            <td key={i}>{LIVE}</td>
                        );
                    }
                    return (
                        <td key={i}>{REPLAY}</td>
                    );  
                }

                if (IS_ALL_STAR_GAME === column) {
                    if (IS_ALL_START_GAME_NUMBER === data[column]) {
                        return (
                            <td key={i}>{YES}</td>
                        );
                    }
                    return (
                        <td key={i}>{NO}</td>
                    );  
                }

                if (VIDEO_DATE_TEMPLATE === column) {
                    return (
                        <td key={i}>{moment(data[VIDEO_DATE_TEMPLATE]).format(DATE_FORMAT)}</td>
                    );
                }

                return (
                    <td key={i}>{data[column]}</td>
                );
            })
        );
    }

    //Renders row buttons
    function RenderButtons(data) {
        return (
            <td className="col-center">
                <ButtonToolbar style={{ display: "flex", justifyContent: "center" }}>
                    {props.rowButtons.map((button, i) => {
                        return (
                            <Button
                                key={i}
                                variant={button.variant}
                              
                                onClick={button.onClick.bind(this, data, button.type)}
                            >
                                <button.icon color={button.color} size={20} />
                            </Button>
                        )
                    })}
                </ButtonToolbar>
            </td>
        );
    }

    return (
        <Table condensed="true" hover responsive bordered>
            <thead>
                <tr>{TableHeader}</tr>
            </thead>
            <tbody>
                {TableList}
            </tbody>
        </Table>
    )
}

export default TableTemplate;